export default __webpack_public_path__ + "static/barlow-v4-latin-300-e145f1ee7d58616254dbacaab00cb1d1.ttf";